import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Operation extends OBase {
  // implement in subclasses
  cal (a, b) {
    console.warning('calculate a b');
  }

  operate (a, b) {
    let aisv3 = (a instanceof THREE.Vector3);
    let aisv2 = (a instanceof THREE.Vector2);
    let bisv3 = (b instanceof THREE.Vector3);
    let bisv2 = (b instanceof THREE.Vector2);

    let result;

    if (aisv3) {
      if (bisv3) {
        result = new THREE.Vector3(
          this.cal(a.x, b.x),
          this.cal(a.y, b.y),
          this.cal(a.z, b.z)
        );
      } else if (bisv2) {
        result = new THREE.Vector3(
          this.cal(a.x, b.x),
          this.cal(a.y, b.y),
          this.cal(a.z, 0)
        );
      } else {
        // b = Number(b)
        result = new THREE.Vector3(
          this.cal(a.x, b),
          this.cal(a.y, b),
          this.cal(a.z, b)
        );
      }
    } else if (aisv2) {
      if (bisv3) {
        result = new THREE.Vector3(
          this.cal(a.x, b.x),
          this.cal(a.y, b.y),
          this.cal(0, b.z)
        );
      } else if (bisv2) {
        result = new THREE.Vector2(
          this.cal(a.x, b.x),
          this.cal(a.y, b.y)
        );
      } else {
        result = new THREE.Vector2(
          this.cal(a.x, b),
          this.cal(a.y, b)
        );
      }
    } else {
      // a = Number(a)
      if (bisv3) {
        result = new THREE.Vector3(
          this.cal(a, b.x),
          this.cal(a, b.y),
          this.cal(a, b.z)
        );
      } else if (bisv2) {
        result = new THREE.Vector2(
          this.cal(a, b.x),
          this.cal(a, b.y)
        );
      } else {
        // b = Number(b)
        result = this.cal(a, b);
      }
    }

    return result;
  }

  update () {
    let dataTrees = Object.keys(this.inputs).map(key => this.getFloatOrVectorInput(key));
    let pOutput = this.getGenericObjectOutput('Result');

    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();

    let count = outDataTrees.length;

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let val = outDataTrees[0].branches[i][j]; // first item
        for (let k = 1; k < count; k++) {
          let arg = outDataTrees[k].branches[i][j];
          if (arg !== null && arg !== undefined) {
            val = this.operate(val, arg);
          }
        }
        outTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Operation.js